import pl from '@/i18n/pl.js'
import en from '@/i18n/en.js'
import de from '@/i18n/de.js'

export default [pl, en, de]
